"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logProgramChange = logProgramChange;
exports.sendToDatadogWithIds = sendToDatadogWithIds;
var _routeMatch = require("./routeMatch");
var _logger = require("@studio/logger");
function sendToDatadogWithIds(getState, loggerName, message, isError) {
  try {
    var _attendeeResponse$Att, _attendeeResponse$Att2;
    var _getState = getState(),
      attendeeResponse = _getState.meeting.attendeeResponse;
    var match = (0, _routeMatch.getBroadcastRouteMatch)(getState);
    var _match$params = match.params,
      teamId = _match$params.teamId,
      eventId = _match$params.eventId,
      broadcastId = _match$params.broadcastId;
    var attendeeId = (_attendeeResponse$Att = attendeeResponse === null || attendeeResponse === void 0 ? void 0 : (_attendeeResponse$Att2 = attendeeResponse.Attendee) === null || _attendeeResponse$Att2 === void 0 ? void 0 : _attendeeResponse$Att2.AttendeeId) !== null && _attendeeResponse$Att !== void 0 ? _attendeeResponse$Att : '';
    var payload = {
      attendeeId: attendeeId,
      broadcastId: broadcastId,
      eventId: eventId,
      teamId: teamId
    };
    (0, _logger.sendToDatadog)(loggerName, payload, message, isError);
  } catch (e) {
    console.warn("Failed to send - ".concat(loggerName, " : ").concat(message, " - log to datadog"), e);
  }
}
function logProgramChange(getState, origin) {
  sendToDatadogWithIds(getState, 'studio-programUpdate-tracker', "Program update initialized in: ".concat(origin), false);
}